<template>
  <div class="input-with-label">
    <span class="input-with-label__label">
      {{ label }}
    </span>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'StatsBuilderInput',
  props: {
    label: {
      default: '',
      type: String,
    },
  },
};
</script>

<style lang="scss">
.input-with-label {
  display: flex;
  flex-direction: column;

  &__label {
    margin-bottom: $global-margin / 2;

    font-size: 14px;
  }
}
</style>
